export default {"src":"/_next/static/media/icone-quark.b2307b1b.svg","height":40,"width":44,"blurWidth":0,"blurHeight":0};